import { useContext, useEffect } from 'react';
import { ErrorHandlerProptypes } from '../properties';
import { CALL_STATUS, CallStatusContext } from '../Context';

function ErrorHandler(props) {
    const {
        callStatus,
        setError
    } = useContext(CallStatusContext);

    const {
        invalid,
        pasteUrl,
        unsupported,
        failure
    } = props;

    useEffect(() => {
        switch (callStatus) {
        case CALL_STATUS.ERROR_INVALID:
            setError(invalid);
            break;
        case CALL_STATUS.ERROR_PASTE_URL:
            setError(pasteUrl);
            break;
        case CALL_STATUS.ERROR_UNSUPPORTED:
            setError(unsupported);
            break;
        case CALL_STATUS.FAILURE:
            setError(failure);
            break;
        case CALL_STATUS.WRITING:
            break;
        default:
            setError(null);
            break;
        }
    }, [callStatus]);
    return null;
}

ErrorHandler.propTypes = ErrorHandlerProptypes;

export default ErrorHandler;
